<template>
  <div>
    <TopBar :page="topBarData" />

    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <div class="d-flex justify-end">
                <v-btn small color="primary" @click="openNewAttempt">New attempt</v-btn>
              </div>
            </v-card-text>

            <v-card-text>
              <OnDashboardTable />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <NewAttemptDialog :open="openOnAttempts" @close="openOnAttempts=false"/>
  </div>
</template>

<script>
import TopBar from '@/components/Layout/TopBar';
import OnDashboardTable from '@/components/Ledger/OnDashboard/OnDashboardTable';
import NewAttemptDialog from '@/components/Ledger/OnDashboard/NewAttemptDialog';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: { 
    TopBar,
    OnDashboardTable,
    NewAttemptDialog,
  },

  data() {
    return {
      topBarData: {
        name: '0N dashboard',
        type: 'on-dashboard',
        showSearch: true,
        menu: false,
        breadcrumbs: [],
        additionalButtons: [],
      },
      openOnAttempts: false,
    }
  },

  computed: {
    ...mapGetters('ledger', ['hasUserGotRoles']),
  },

  methods: {
    ...mapActions('alerts', ['setAlert']),

    openNewAttempt() {
      if(this.hasUserGotRoles(['can-create-dd-runs-attempts-and-files'])) {
        this.openOnAttempts = true;
      } else {
        this.setAlert({ type: 'error', message: `You do not have permission to carry out this action` });
      }
    }
  }
}
</script>

<style lang="scss" scoped>  

</style>